function load_portfolio_images() {
  jQuery('.portfolio .bg-block').each(function (i, obj) {
    var img = jQuery(this).attr('data-bg');
    var item = jQuery(this);

    jQuery('<img src="' + img + '">').load(function () {
      item.css('background-image', 'url(' + img + ')');
      setTimeout(function () {
        item.addClass('loaded');
      }, 10);

      setTimeout(function () {
        item.addClass('loaded-full');
      }, 800);
    });
  });

  // Portfolio hover
  jQuery('.portfolio a.item').on('mouseenter', function () {
    if (jQuery(window).width() >= 768) {
      var item = jQuery(this);
      var plus = jQuery(this).find('.plus');
      var portfolioListTween = new TimelineMax();

      portfolioListTween
        .fromTo(plus, 0.3, { opacity: 0, y: 40, rotate: 0 }, { opacity: 1, y: 0, rotate: 180 })
        .play();
    }
  });
  jQuery('.portfolio a.item').on('mouseleave', function () {
    if (jQuery(window).width() >= 768) {
      var item = jQuery(this);
      var plus = jQuery(this).find('.plus');
      var portfolioListTween = new TimelineMax();

      portfolioListTween
        .fromTo(plus, 0.3, { opacity: 1, y: 0, rotate: 180 }, { opacity: 0, y: 40, rotate: 0 })
        .play();
    }
  });

  // Portfolio masonry layout
  var $grid = jQuery('.m-grid').masonry({
    // options
    itemSelector: '.m-grid-item',
    percentPosition: true,
    columnWidth: '.m-grid-sizer'
  });

  // layout Masonry after each image loads
  $grid.imagesLoaded().progress(function () {
    $grid.masonry('layout');
  });

  //$grid.masonry('layout');
}


jQuery(document).ready(function () {
  jQuery(document).on('facetwp-refresh', function () {
    jQuery('.facetwp-template').addClass('loading');
  });

  jQuery(document).on('facetwp-loaded', function () {
    jQuery('.facetwp-template').removeClass('loading');
    load_portfolio_images();
  });

});


